import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IMAGES, TREATMENTS } from '../data/content';

const cats = ['Skin Diseases','Hair Problems','Pain Problems','Other Diseases'];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dropOpen, setDropOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => setDropOpen(false), [loc]);

  const lc = (path) => ({
    fontSize: '13px', letterSpacing: '0.2px',
    color: loc.pathname === path ? '#C8941A' : 'rgba(240,230,216,0.6)',
    transition: 'color 0.2s', fontWeight: 400, whiteSpace: 'nowrap',
    textDecoration: 'none',
  });

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      height: '68px',
      background: scrolled ? 'rgba(8,4,2,0.96)' : 'linear-gradient(to bottom, rgba(8,4,2,0.8), transparent)',
      backdropFilter: scrolled ? 'blur(20px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(255,255,255,0.05)' : 'none',
      transition: 'all 0.4s ease',
      display: 'flex', alignItems: 'center',
    }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 36px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px' }}>

        {/* Logo + Custom Font Name */}
        <Link to="/" onClick={() => window.scrollTo({top:0,behavior:"smooth"})} style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0, textDecoration: 'none' }}>
          <img src='https://ik.imagekit.io/gnzsnmo3fr/vaidyam/hero/logo.png' alt="Vaidyam" style={{ height: '34px', width: 'auto', objectFit: 'contain' }} onError={e => e.target.style.display='none'} />
          <span style={{ fontFamily: 'Saman, Cormorant Garamond, serif', fontSize: '22px', color: '#F0E6D8', letterSpacing: '1px', lineHeight: 1, whiteSpace: 'nowrap' }}>
            Vaidyam Ayurveda
          </span>
        </Link>

        {/* Nav links */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '24px', flex: 1, justifyContent: 'center' }}>
          {[['/', 'Home'], ['/about', 'About'], ['/panchakarma', 'Panchakarma'], ['/kerala-therapies', 'Kerala Therapies']].map(([path, label]) => (
            <Link key={path} to={path} style={lc(path)}
              onMouseEnter={e => e.currentTarget.style.color = '#F0E6D8'}
              onMouseLeave={e => e.currentTarget.style.color = loc.pathname === path ? '#C8941A' : 'rgba(240,230,216,0.6)'}
            >{label}</Link>
          ))}

          {/* Treatments dropdown */}
          <div style={{ position: 'relative' }}
            onMouseEnter={() => setDropOpen(true)}
            onMouseLeave={() => setDropOpen(false)}
          >
            <Link to="/treatments" style={{ ...lc('/treatments'), display: 'flex', alignItems: 'center', gap: '4px' }}>
              Treatments
              <svg width="9" height="5" viewBox="0 0 9 5" fill="none" style={{ opacity: 0.4, transition: 'transform 0.2s', transform: dropOpen ? 'rotate(180deg)' : 'none' }}>
                <path d="M1 1l3.5 3L8 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
              </svg>
            </Link>
            {dropOpen && (
              <div style={{ position: 'absolute', top: '100%', left: '50%', paddingTop: '12px', zIndex: 200 }}>
                <div style={{
                  background: '#0C0602', border: '1px solid rgba(255,255,255,0.07)',
                  borderRadius: '6px', padding: '20px 24px',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.7)',
                  width: '560px', display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '16px',
                  transform: 'translateX(-50%)',
                  animation: 'dropIn 0.18s ease',
                }}>
                  {cats.map(cat => (
                    <div key={cat}>
                      <div style={{ fontSize: '9px', letterSpacing: '1.8px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 600, marginBottom: '8px', paddingBottom: '5px', borderBottom: '1px solid rgba(200,148,26,0.15)' }}>{cat}</div>
                      {TREATMENTS.filter(t => t.category === cat).map(t => (
                        <Link key={t.id} to={`/treatments/${t.id}`}
                          style={{ display: 'block', fontSize: '12.5px', color: 'rgba(240,230,216,0.45)', padding: '3px 0', transition: 'color 0.15s', textDecoration: 'none' }}
                          onMouseEnter={e => e.target.style.color = '#F0E6D8'}
                          onMouseLeave={e => e.target.style.color = 'rgba(240,230,216,0.45)'}
                        >{t.name}</Link>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {[[ '/gallery', 'Gallery'], ['/blog', 'Blogs'], ['/contact', 'Contact']].map(([path, label]) => (
            <Link key={path} to={path} style={lc(path)}
              onMouseEnter={e => e.currentTarget.style.color = '#F0E6D8'}
              onMouseLeave={e => e.currentTarget.style.color = loc.pathname === path ? '#C8941A' : 'rgba(240,230,216,0.6)'}
            >{label}</Link>
          ))}
        </div>

        {/* CTAs */}
        <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
          <a href="tel:+919425706830" style={{
            fontSize: '12px', color: 'rgba(240,230,216,0.5)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '3px', padding: '8px 16px',
            textDecoration: 'none', transition: 'all 0.25s', whiteSpace: 'nowrap',
          }}
            onMouseEnter={e => { e.currentTarget.style.color = '#F0E6D8'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.25)'; }}
            onMouseLeave={e => { e.currentTarget.style.color = 'rgba(240,230,216,0.5)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; }}
          >Call Now</a>
          <Link to="/book-appointment" style={{
            fontSize: '12px', color: '#C8941A',
            border: '1px solid rgba(200,148,26,0.45)',
            borderRadius: '3px', padding: '8px 16px',
            textDecoration: 'none', transition: 'all 0.25s', whiteSpace: 'nowrap',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = '#C8941A'; e.currentTarget.style.color = '#0C0602'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#C8941A'; }}
          >Book Consultation</Link>
        </div>
      </div>
      <style>{`
        @keyframes dropIn { from{opacity:0;transform:translateX(-50%) translateY(-8px)} to{opacity:1;transform:translateX(-50%) translateY(0)} }
        @font-face { font-family: 'Saman'; src: url('/fonts/Saman.ttf') format('truetype'); }
      `}</style>
    </nav>
  );
}
